"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = exports.formatWithZero = void 0;
const formatWithZero = (value) => {
    return `${value < 10 ? '0' : ''}${value}`;
};
exports.formatWithZero = formatWithZero;
const formatValue = (value, withTime, withSeconds, is12Hours, texts) => {
    let result = `${(0, exports.formatWithZero)(value.getDate())}/${(0, exports.formatWithZero)(value.getMonth() + 1)}/${value.getFullYear()}`;
    if (withTime) {
        let hours = String(value.getHours());
        const timePeriod = value.getHours() > 11 ? texts.pm : texts.am;
        if (is12Hours) {
            hours = `${value.getHours() > 12 ? value.getHours() - 12 : value.getHours()}`;
            if (hours === '0') {
                hours = '12';
            }
        }
        result += ` ${hours}:${(0, exports.formatWithZero)(value.getMinutes())}`;
        if (withSeconds) {
            result += `:${(0, exports.formatWithZero)(value.getSeconds())}`;
        }
        if (is12Hours) {
            result += ` ${timePeriod}`;
        }
    }
    return result;
};
exports.formatValue = formatValue;
//# sourceMappingURL=formatValue.js.map